import type { FaireProductEntity } from "../../entity_types/product";

export const p_r9pzzxsm3u: FaireProductEntity = {
  token: "p_r9pzzxsm3u",
  type: "product",
  name: "Mini Oyster Trinket Tray-Trinket Dish-Ceramic Tasting Bowl",
  brandName: "ChagoArt",
  imageUrl:
    "https://cdn.faire.com/fastly/b0e2cd2dead28d1d91833d2a13b9a866db899978370b3f32718b854b4191dd07.jpeg",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/db6b250f8bd30d445157924b624107ed6e60b36e2d1f6830a20071498a0545b6.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
